import { connect } from 'react-redux'
import { loginUserClient, clientValidateToken } from '../../store/user/duck'
import ImpersonatUserForm from './component'
const ImpersonatUser = connect(
  // Map state to props
  (state) => ({
    user: state.user.users,
    clientloginPhase: state.user.clientloginPhase,
    clientloginError: state.user.clientloginError,
    isAuthenticated:state.user.clientloginPhase
  }),
  // Map actions to props
  {
    loginUserClient,
    clientValidateToken
  }
)(ImpersonatUserForm)
export default ImpersonatUser
